import { ListDivider } from '../../ListDivider'
import { ListItem } from '../../ListItem'

import * as styles from './Extra.module.css'

function Extra({ Component, ...restProps }) {
  return (
    <div className={styles.extra}>
      <ListDivider className={styles.divider} />
      <ListItem>
        <Component {...restProps} />
      </ListItem>
    </div>
  )
}

export default Extra
